// eslint-disable-next-line yi/avoid-relative-parent-imports
import { MembershipPlanInterval, MembershipTier } from '../gql/generated/typesClient';
import { ANNUAL_TIER } from './AnnualTier';
import { UserMembershipTier } from './UserMembershipTier';

type Subscription = {
  tier: MembershipTier | null;
  interval: MembershipPlanInterval | null;
};

export class UserMembership implements UserMembershipTier {
  private subsription: Subscription | null = null;
  constructor(user: Subscription | null) {
    this.subsription = user;
  }

  tier() {
    if (this.subsription === null) {
      return null;
    }

    if (
      this.subsription?.tier === 'Digital' &&
      this.subsription?.interval === MembershipPlanInterval.YEAR
    ) {
      return ANNUAL_TIER;
    }
    return this.subsription?.tier;
  }
}
